export default __webpack_public_path__ + "static/media/snapchat.21e3b95b.webp";